// Specialty Model

import { Model } from '@vuex-orm/core'
import { getDateLabel } from '@/utils/labelutils'
import i18n from '@/i18n'

export default class Specialty extends Model {
  static entity = 'specialties'
  static _subclasses = {}

  static fields() {
    return {
      id: this.attr(null),
      name: this.attr(''),
      // internships: this.hasMany()
      logbooks: this.hasMany(Logbook, 'specialty'),
      internships: this.hasMany(Internship, 'specialty')
    }
  }

  static registerSpecialty(specialtyName, specialtyObj) {
    // this.database.register(specialtyName, specialtyObj)

    this._subclasses[specialtyName] = specialtyObj
  }

  static getSpecific(specialtyName) {
    return this._subclasses[specialtyName] || this
  }

  static getLabel(log, component) {
    const item = log[component.id]
    if (component.id === 'internship') {
      return this.getInternshipLabel(item)
    } else if (
      [
        'text-field',
        'hint-field',
        'numeric-field',
        'age',
        'age-field',
        'p-tnm-staging',
        'text-area'
      ].includes(component.type)
    ) {
      return item
    } else if (component.type === 'date-picker') {
      return getDateLabel(item)
    } else if (
      component.type === 'single-select-tree' ||
      component.type === 'multi-select-tree'
    ) {
      return this.getTreeLabel(item, component)
    } else if (component.type === 'checkbox') {
      return item ? i18n.t('common.Yes') : i18n.t('common.No')
    } else if (component.type === 'icd10' || component.type === 'icd10-sec') {
      let label = []
      if (item) {
        item
          .map(e => {
            if (typeof e === 'string') {
              const icd = component.getOptionLabel(e) || e
              label.push(icd.split(':')[1])
            } else if (e && e.text) {
              label.push(component.getOptionLabel(e.text) || e.text)
            }
          })
          .join(', ')
      }
      return label.join(', ')
    } else if (typeof item === 'string') {
      return component.getOptionLabel(item) || item
    } else if (Array.isArray(item)) {
      return item
        .map(e => {
          if (typeof e === 'string') {
            return component.getOptionLabel(e) || e
          } else if (e && e.text) {
            return component.getOptionLabel(e.text) || e.text
          }
        })
        .join(', ')
    } else if (item && typeof item === 'object') {
      return item.text || item.value || item.id
    }
  }

  static getTreeLabel(item, component) {
    let texts = null
    if (item) {
      let treeLabels = TreeDataDictionary.query()
        .where('tabName', component.tabName)
        .first().flatTreeData
      texts = item
        .map(
          id => treeLabels.find(treeLabel => treeLabel.id === id).label || id
        )
        .join(', ')
    }
    return texts
  }

  static getInternshipLabel(internship) {
    let internshipLabel = (
      Option.query()
        .where('component', 'internship')
        .get()
        .find(i => i.value === internship) || {}
    ).text
    if (!internshipLabel) {
      internshipLabel =
        (
          Internship.query()
            .get()
            .find(i => i.id === internship) || {}
        ).name || ''
    }
    return internshipLabel
  }
}
export class FamilyMedicine extends Specialty {
  static entity = 'familyMedicine'
  static baseEntity = 'specialties'

  static fields() {
    return {
      ...super.fields()
    }
  }
}

export class InternalMedicine extends Specialty {
  static entity = 'internal-medicine'
  static baseEntity = 'specialties'

  static fields() {
    return {
      ...super.fields()
    }
  }
}

export class Pathology extends Specialty {
  static entity = 'pathology'
  static baseEntity = 'specialties'

  static fields() {
    return {
      ...super.fields(),
      diagnoses: this.attr([]),
      organSystems: this.attr([])
    }
  }
}

export class Logbook extends Model {
  static entity = 'logbooks'

  static fields() {
    return {
      id: this.attr(null),
      name: this.attr(''),
      specialty: this.attr('general-surgery'), // TODO: make general
      // sections: this.belongsToMany(Section, LogbookSection, 'logbook', 'section'),
      components: this.belongsToMany(
        Component,
        LogbookComponent,
        'logbook',
        'component'
      )
    }
  }
}

export class Section extends Model {
  static entity = 'sections'

  static fields() {
    return {
      id: this.attr(null),
      title: this.attr(''),
      components: this.hasMany(Component, 'section')
    }
  }
}

// Pivot table - only for keeping relations
export class LogbookSection extends Model {
  static entity = 'logbookSections'
  static primaryKey = ['logbook', 'section']

  static fields() {
    return {
      logbook: this.attr(null),
      section: this.attr(null)
    }
  }
}
// Pivot table - only for keeping relations
export class LogbookComponent extends Model {
  static entity = 'logbookComponents'
  static primaryKey = ['logbook', 'component']

  static fields() {
    return {
      logbook: this.attr(null),
      component: this.attr(null)
    }
  }
}

export class LogbookComponentConditions extends Model {
  static entity = 'logbookComponentConditions'
  static primaryKey = ['id']

  static fields() {
    return {
      id: this.attr(''),
      componentId: this.attr(''),
      conditionalComponentId: this.attr(''),
      conditionalComponentOptionsIds: this.attr(''),
      condition: this.attr(''),
      action: this.attr('')
    }
  }
}

export class Component extends Model {
  static entity = 'components'
  static primaryKey = 'uid'

  static fields() {
    return {
      uid: this.attr(''),
      id: this.attr(null),
      label: this.attr(''),
      required: this.attr(false),
      logbooks: this.attr([]),
      type: this.attr(''),
      size: this.attr(null),
      sizeMobile: this.attr(null),
      show: this.attr(false),
      encrypt: this.attr(false),
      statistics: this.attr(false),
      options: this.hasMany(Option, 'component', 'id'),
      conditionalOptions: this.attr([]),
      condition: this.attr([]),
      favourite: this.attr([]),
      tabName: this.attr('')
    }
  }

  getOptionLabel(id) {
    return (this.options.find(option => option.value === id) || {}).text
  }
}

export class Option extends Model {
  static entity = 'options'
  static primaryKey = ['$id', 'component']

  static fields() {
    return {
      component: this.attr(null),
      text: this.attr(''),
      value: this.attr(null)
    }
  }
}

export class OptionDiagnosisPathology extends Option {
  static entity = 'optionspathology'
  static primaryKey = '$id'

  static fields() {
    return {
      ...super.fields(),
      parentId: this.attr(''),
      categoryId: this.attr(''),
      organSystemId: this.attr(''),
      organSystem2Id: this.attr(''),
      morphologicGroupId: this.attr(''),
      morphologicGroup2Id: this.attr('')
    }
  }
}

export class OrganSystem2Pathology extends Option {
  static entity = 'organSystem2Pathology'
  static primaryKey = '$id'

  static fields() {
    return {
      ...super.fields(),
      organSystemId: this.attr('')
    }
  }
}

export class Internship extends Model {
  static entity = 'internships'
  static primaryKey = 'id'

  static fields() {
    return {
      id: this.attr(''),
      label: this.attr(''),
      specialtyId: this.attr(null),
      specialtyName: this.attr(null)
    }
  }

  static getAvailableInternships(userInternships, specialty) {
    if (!specialty) {
      return Internship.query().get()
    }

    const specialtyInternships = Internship.query()
      .get()
      .filter(i => {
        return (
          i.specialtyId === specialty &&
          userInternships.find(ui => ui.internship === i.id)
        )
      })

    return specialtyInternships
  }
}

export class AnesthesiologyLog extends Model {
  static entity = 'anesthesiologyLogs'
  static primaryKey = 'id'

  static fields() {
    return {
      id: this.attr(''),
      logbook: this.attr(''),
      'anesthesia-regimen': this.attr(''),
      internship: this.attr(''),
      age: this.number(),
      asa: this.attr(''),
      background: this.attr(''), // free text field
      'surgical-procedure': this.attr(''), // free text field
      'anesthesia-type': this.attr(''),
      'anesthesia-procedure': this.attr(''),
      'loco-regional-guidance': this.attr(''),
      duration: this.attr(''),
      'accidents-and-complications': this.attr(''), // free text field
      autonomy: this.attr(''),
      notes: this.attr('') // free text field
    }
  }
}

export class TreeDataDictionary extends Model {
  static entity = 'treeDataDictionary'
  static primaryKey = 'tabName'

  static fields() {
    return {
      tabName: this.attr(''),
      treeData: this.attr([]),
      flatTreeData: this.attr([])
    }
  }
}
